/*
 * @Author: chengyu
 * @Date: 2022-09-23 16:32:56
 * @Description: 类型判断
 */
var _toString = Object.prototype.toString;
/**
 * @description: 判断值是否未某个类型
 */
export function is(val, type) {
    return _toString.call(val) === "[object ".concat(type, "]");
}
/**
 * @description: 是否为对象
 */
// eslint-disable-next-line
export var isObject = function (val) {
    return val !== null && is(val, 'Object');
};
/**
 * @description:  是否为函数
 */
// eslint-disable-next-line
export function isFunction(val) {
    return typeof val === 'function';
}
/**
 * @description:  是否为数组
 */
export function isArray(val) {
    return val && Array.isArray(val);
}
/**
 * 判断是否为空数组
 * @param val
 */
export function isEmptyArray(val) {
    return isArray(val) && val.length === 0;
}
/**
 * 数字
 * @param val
 */
export function isNumber(val) {
    return typeof val === 'number';
}
/**
 * Error
 */
export function isError(val) {
    return is(val, 'Error');
}
/**
 * 字符串
 * @param val
 */
export function isString(val) {
    return is(val, 'String');
}
/**
 * boolean 值
 * @param val
 */
export function isBoolean(val) {
    return typeof val === 'boolean';
}
/**
 * - 判断是抛出的`NetworkError`异常
 * - 或者异常对象中包含`response`、`fetchData`
 *
 * 埋点的时候，可以从`response`、`fetchData`中取值
 */
export function isNetworkError(err) {
    if (isError(err)) {
        if (err.name === 'NetworkError') {
            return true;
        }
        else if (isObject(err.response) || isObject(err.fetchData)) {
            return true;
        }
    }
    return false;
}
/**
 * 检查返回数据是否存在
 */
export function isLbsResponseExist(response) {
    return (isObject(response) &&
        isObject(response.data) &&
        isObject(response.data.data));
}
/**
 * 长度大于0的数组
 * 结合`isLbsResponseExist`方法一起使用
 */
export function isLbsResultArrayExist(response, key) {
    if (key === void 0) { key = 'pois'; }
    var exist = isLbsResponseExist(response);
    if (exist) {
        // @ts-ignore
        var data = response.data.data[key];
        return isArray(data) && data.length;
    }
    return false;
}
//# sourceMappingURL=data:application/json;base64,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